import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { BurgerMenu, IconClose, Logo, VerticalSeparator } from '../../assets';
import { LanguageSwitcher } from '../LanguageSwitcher/LanguageSwitcher';

import './Header.css'
import cn from 'classnames';

export const Header: React.FC = () => {
    const { t } = useTranslation();
    const [isMenuActive, setMenuActive] = useState<boolean>(false);

    const handleOpenMenu = () => setMenuActive(true);
    const handleCloseMenu = () => setMenuActive(false);

    return (
        <header id="header" className={cn('Header', isMenuActive && 'Header-active')}>
            <div className="Header-heading">
                <a href="/" className="Header-logo" aria-label="TrendVision Logo">
                    <Logo />
                </a>
                {isMenuActive ?
                    (
                        <IconClose
                            onClick={handleCloseMenu}
                            className="Header-menu"
                        />
                    ) : (
                        <BurgerMenu
                            onClick={handleOpenMenu}
                            className="Header-menu"
                        />
                    )}
            </div>
            <VerticalSeparator className="Header-separator" />
            <nav className="Header-navigation">
                <a href="#research" onClick={handleCloseMenu} className="Header-link">{t('header.research')}</a>
                <a href="#cases" onClick={handleCloseMenu} className="Header-link">{t('header.cases')}</a>
                <a href="#why" onClick={handleCloseMenu} className="Header-link">{t('header.about')}</a>
                <a href="#prices" onClick={handleCloseMenu} className="Header-link">{t('header.prices')}</a>
                <a href="#trial" onClick={handleCloseMenu} className="Header-link">{t('header.trial')}</a>
                <LanguageSwitcher />
            </nav>
        </header>
    )
};
